// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import calendarHeart02Icon from "@/assets/icons/calendar-heart-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CalendarHeart02IconProps = Omit<IconProps, "name">;

export function CalendarHeart02Icon(props: CalendarHeart02IconProps): React.ReactNode {
  return <Icon name={calendarHeart02Icon} {...props} />;
}
